/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

interface Props {
  bemModifier: number | string;
  isLoading: boolean;
  loadingError: boolean;
  showFallbackOnLoading?: boolean;
  fallbackClass?: string;
  fallbackText?: string;
  fallbackComponent?: JSX.Element;
}

export default function ImageFallback({
  bemModifier,
  isLoading,
  loadingError,
  showFallbackOnLoading,
  fallbackClass,
  fallbackText,
  fallbackComponent,
}: Props): JSX.Element | null {
  const fallback = (
    <div className={`image-loader-fallback-container ${fallbackClass}`}>
      <p className="ellipsis-text" id={`ImageLoader_fallback___${bemModifier}`}>
        {fallbackText}
      </p>
    </div>
  );

  if (showFallbackOnLoading) {
    if (!isLoading && !loadingError) {
      return null;
    }

    return fallback;
  }

  if (isLoading || !loadingError) {
    return null;
  }

  if (fallbackComponent) {
    return fallbackComponent;
  }

  return fallback;
}
